import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DropdownField } from '../../../models/Field';

@Component({
  selector: 'dropdown-combo-kendo',
  template: `<div [formGroup]="form" class="form-group">
    <label [attr.for]="fieldKey">{{ field.label }}</label>
    <input
      [formControlName]="field.key"
      type="hidden"
      id="{{ field.key + '-hidden' }}"
    />
    <div
      class="form-control input"
      [style.width]="field.size ? field.size + 'em' : ''"
    >
      <input
        id="{{ field.key + '-kendo' }}"
        class="form-control input"
        [style.width]="field.size ? field.size + 'em' : ''"
        style="max-width: 100%;"
      />
    </div>
    <error-box [form]="form" [field]="field"></error-box>
  </div>`,
})
export class DropdownComboKendoComponent implements OnInit, OnDestroy {
  @Input() form: FormGroup;
  @Input() field: DropdownField;

  formStatusChangeSubscription;

  get control() {
    return this.form.controls[this.field.key];
  }
  get errorKeys() {
    return Object.keys(this.control.errors);
  }

  ngOnInit() {
    this.formStatusChangeSubscription = this.form.statusChanges.subscribe(
      () => {
        const kendoComponent = $(`#${this.field.key}-kendo`).data(
          'kendoComboBox'
        );
        if (kendoComponent) {
          // Check per-control disabled, not the whole form
          kendoComponent.enable(!this.control.disabled);
        }
      }
    );
  }

  ngAfterViewInit() {
    $(`#${this.field.key}-kendo`)
      .kendoComboBox({
        placeholder: this.field.placeholder,
        dataTextField: 'label',
        dataValueField: 'value',
        template: this.field.images
          ? '<span class="k-state-default" style="vertical-align: top; display: inline-block; width: 25px; height: 25px; background: center / contain no-repeat url(\'https://previews.123rf.com/images/aquir/aquir1311/aquir131100316/23569861-sample-grunge-red-round-stamp.jpg\');"></span>' +
            '<span class="k-state-default" style="vertical-align: top; color: black; padding-left: 15px; line-height: 25px;">#: data.label #</span>'
          : undefined,
        dataSource: this.field.items,
        filter: 'contains',
        suggest: false,
        select: ((evt) => {
          const value = evt.dataItem ? evt.dataItem.value : null;
          if (
            value &&
            this.field.items.filter((item) => item.value === value).length
          ) {
            this.form.controls[`${this.field.key}`].setValue(value);
            this.form.controls[`${this.field.key}`].markAsTouched();
          } else {
            evt.preventDefault();
          }
        }).bind(this),
      })
      .data('kendoComboBox');

    // Apply disabled state immediately on first render
    const kendoCB = $(`#${this.field.key}-kendo`).data('kendoComboBox');
    if (kendoCB) {
      kendoCB.enable(!this.control.disabled);
    }

    $(`#${this.field.key}-kendo`)
      .blur((evt) => {
        this.form.controls[`${this.field.key}`].markAsTouched();
      })
      .bind(this);
  }

  ngOnDestroy() {
    this.formStatusChangeSubscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./app/insa-components/insa-generic-form/generic-editor/components/fields/dropdown/dropdown-combo-kendo.component.ts